module.exports = __webpack_public_path__ + "img/POSTMAN.6381ebb7.png";